/**
 * @author Ariel
 * @description 能力评估
 * @createDate 2020-7-16
 */
import React from "react";
import { framework_tool, component_tool, utils_tool } from '../../../tool'
import { connect } from "dva";
import { PositionRadar } from '../../../components'
import mockData from './mockData'
import '../../../styles/containers/org/abilityAssess/index.less'

let { WizTabs, WizTimeline, WizTypography, WizSpin } = component_tool
const { Paragraph } = WizTypography
let { WizContainer, modelUtils } = framework_tool
let { Session, Storage } = utils_tool

class AbilityAssess extends WizContainer {
  componentName = 'abilityAssess';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _componentWillMount = () => {
    let record = this.props.location.record;
    if (record) {
      Session.set('abilityAssess', record);
      this.record = record;
    }
    if (Session.get('abilityAssess')) {
      this.record = Session.get('abilityAssess');
    }
  };


  _componentDidMount() {
    let personId = ''
    if (this.record && this.record['personId']) {
      personId = this.record['personId']
    } else {
      let user = Storage.getStorage('user')
      if (user && user['personId']) {
        personId = user['personId']
      } else {
        return
      }
    }
    this.doAction({
      path: 'abilityAssess/getStudentAllAbilityItemByPersonId',
      payload: {
        key: 'getStudentAllAbilityItemByPersonId',
        apiParams: { personId }
      },
    })
    this.href = location.href.replace('/#/train/abilityAssess', '');
    this.setInterval = setInterval(() => {
      if (location.href.replace('/#/train/abilityAssess', '') !== this.href) {
        location.reload()
      }
    }, 1500);
  }


  _componentWillUnmount() {
    clearInterval(this.setInterval)
  }

  propsAndStateOnChange = {
    dataList: this._dataList.bind(this),
  }

  _dataList(nextProps, nextState) {
    let dataList = nextProps.dataList;
    if (dataList.code == 1) {
    } else {
      wizNotice.error(dataList['msg'] ? dataList['msg'] : '获取数据失败，请稍后再试');
    }
    return true;
  }

  /**
   * 转换数据格式
   */
  _getRadarDate = (data) => {
    let o = {
      data: [],
      dataFormat: {
        type: 'fold',
        fields: [],
        key: 'user',
        value: 'score',
      },
      cols: {
        score: {
          min: 0,
          max: 0,
          tickInterval: 10
        },
        user: {},
      }
    }

    let _data = [];
    let fields = [];
    let formatter = {};
    let max = 0;
    let min = 0;
    if (!data || !data['item']) {
      return;
    }
    let item = data['item']
    item.forEach(i => {
      if (i['max'] > max) {
        max = i['max']
      }
      if (i['min'] > min) {
        min = i['min']
      }
      _data.push({ item: i['name'], id: i['id'] })
    });
    if (data['data'] && data['data'].length) {
      data['data'].forEach(d => {
        formatter[d['name']] = d['name']
        fields.push(d['name'])
        _data.forEach(_d => {
          _d[d['name']] = d['item'][_d['id']]
        });
      });
    }
    let _r_data = []
    _r_data.push(_data[0])
    for (let index = _data.length - 1; index >= 0; index--) {
      if (index > 0) {
        _r_data.push(_data[index])
      }
    }
    o['data'] = _r_data;
    o['dataFormat']['fields'] = fields;
    o['cols']['user']['formatter'] = val => (formatter[val]);
    o['cols']['score']['max'] = max;
    o['cols']['score']['min'] = min;
    o['cols']['score']['tickInterval'] = max / 10;
    return o
  }


  returnItem = (ld, timelineStyle) => {
    return (
      <WizTimeline.Item
        style={timelineStyle}
        dot={<div className='time-line-blue' />}
      >
        {
          <div className='title-view' style={timelineStyle}>
            <Paragraph className='title-view-font' >{ld['name']}</Paragraph>
            <Paragraph type='secondary'>{ld['date']}</Paragraph>
          </div>
        }
      </WizTimeline.Item>
    )
  }

  returnRadar = (ld, data, timelineStyle) => {
    let style = { ...timelineStyle }
    style.width = style.height
    return (
      <WizTimeline.Item key={ld['id']}
        style={style}
        dot={<div className='time-line-blue' />}
      >
        <div
          key={ld['id']}
          style={timelineStyle}
        >
          <PositionRadar radarName={ld['name']} radarKey={ld['id']} radarProps={data} />
        </div>
      </WizTimeline.Item>
    )
  }

  _renderRadar = (data = [], timelineStyle) => {
    let _r = []
    data.forEach(d => {
      const { list, name } = d
      _r.push(
        <WizTabs.TabPane tab={name} key={d['id']}>
          <div className='main-div'>
            <WizTimeline mode={'right'} className='timeline-main'>
              {list.map((ld) => { return this.returnItem(ld, timelineStyle) })}
            </WizTimeline>
            <WizTimeline mode={'left'}>
              {list.map((ld) => {
                let _data = this._getRadarDate(ld)
                return this.returnRadar(ld, _data, timelineStyle)
              })}
            </WizTimeline>
          </div>
        </WizTabs.TabPane>
      )
    });
    return _r
  }


  _render() {
    let data = this.props['dataList'] && this.props['dataList']['data'] ? this.props['dataList']['data'] : [];
    let timelineStyle = { height: 650 }
    if (this.props.abilityAssessLoading) {
      return (
        <div className='ability-assess-spin'>
          <WizSpin delay={200} className='ability-assess-spin-loading' spinning={this.props.abilityAssessLoading} tip='加载中' />
        </div>
      )
    } else if (!data || !data.length) {
      return (
        <div className='ability-assess-spin'>
          <img height={300} width={300} src={constants.files.empty_png} />
        </div>
      )
    } else {
      return (
        <div className='ability-assess'>
          <WizTabs>
            {this._renderRadar(data, timelineStyle)}
          </WizTabs>
        </div>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { abilityAssess } = state;
  const ass = modelUtils.getModelEntity(abilityAssess, "getStudentAllAbilityItemByPersonId");
  const load = modelUtils.getLoadingState(state, ['abilityAssess']);
  return {
    dataList: ass,
    ...load
  }
};

export default connect(mapStateToProps)(AbilityAssess);

